import { enableProdMode, importProvidersFrom, isDevMode, provideZoneChangeDetection } from '@angular/core';

import { environment } from '@env/environment';
import { Amplify } from 'aws-amplify';
import authConfig from '@core/auth/auth.config';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthInterceptor } from '@core/auth/auth.interceptor';
import { ErrorInterceptor } from '@core/error/error.interceptor';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AmplifyAuthenticatorModule, translations } from '@aws-amplify/ui-angular';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { appRoutes } from './app/app.routes';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { provideNoopAnimations } from '@angular/platform-browser/animations';
import { AppComponent } from './app/app.component';
import { I18n } from 'aws-amplify/utils';
import { vocabulary } from '@core/i18n/localisation';
import { TranslocoHttpLoader } from './transloco-loader';
import { provideTransloco } from '@jsverse/transloco';
import { provideTranslocoLocale } from '@jsverse/transloco-locale';

if (environment.production) {
  enableProdMode();
}

Amplify.configure({
  Auth: authConfig,
});

// Language is set in app.component.ts
// This localisation is only for the aws amplify login portal
I18n.putVocabularies(translations);
I18n.putVocabularies(vocabulary);

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    provideTranslocoLocale(),
    importProvidersFrom(BrowserModule, FormsModule, AmplifyAuthenticatorModule, ReactiveFormsModule, NgbModule),
    provideRouter(appRoutes, withComponentInputBinding()),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    //{ provide: LOCALE_ID, useValue: "fr" },
    provideHttpClient(withInterceptorsFromDi()),
    provideNoopAnimations(),
    provideHttpClient(),
    provideTransloco({
      config: {
        availableLangs: ['nl', 'fr'],
        defaultLang: localStorage.getItem('activeLanguage') || 'nl',
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
  ],
}).catch((err) => console.error(err));
